import ContentCenter from "../../ui/ContentCenter";
import { FingerSkillsIntroBanner } from "../FingerSkills/FingerSkills";
import React, { useEffect, useState } from "react";
import PlayButton from "../../ui/PlayButton";
import Timer from "../../ui/Timer";

const GESTURE_COUNT = 34;
const TIME_BETWEEN_CARDS = 4000;
const MAX_CARDS = 10;

export default ({ level }: any) => {
  const [count, setCount] = useState(0);
  const [cards, setCards] = useState<any>(
    Array.from(Array(GESTURE_COUNT)).map((i, index) => index + 1)
  );
  const [time,setTime] = useState(TIME_BETWEEN_CARDS);
  const [randomCard, setRandomCard] = useState(null);

  useEffect(() => {
    if (time <= 0) return;
    const timer = setTimeout(() => setTime(time-500),500);
    return () => clearTimeout(timer);
  },[time]);

  useEffect(() => {
    if (count >= MAX_CARDS) {
      return;
    }
    setRandomCard(cards[Math.floor(Math.random() * (cards.length - 1))]);
    setTimeout(() => {
      setCount(count + 1);
    }, TIME_BETWEEN_CARDS);
    setTime(TIME_BETWEEN_CARDS);
  }, [count]);

  if (!randomCard) return <></>;

  const card = (
    <div style={{ display: "flex", justifyContent:"center", alignItems:"center"}}>
      <img src={`/armsup/card-${randomCard}.png`} />
    </div>
  );

  return (
    <ContentCenter column style={{height: "100%"}}>
      {card}

      {count >= MAX_CARDS ? (
        <PlayButton onClick={() => setCount(0)}>Spiel wiederholen</PlayButton>
      ) : (
        <></>
      )}
      <Timer time={time}/>
    </ContentCenter>
  );
};
